// 抑制 Quill.js 的 DOMNodeInserted 废弃警告（不影响功能）
(function() {
  const deprecatedEvents = ['DOMNodeInserted', 'DOMNodeRemoved', 'DOMSubtreeModified', 'DOMAttrModified', 'DOMCharacterDataModified'];
  const origAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (deprecatedEvents.includes(type)) return; // 静默忽略
    return origAddEventListener.call(this, type, listener, options);
  };
})();

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'
import './styles/global.css'

Vue.use(ElementUI, { size: 'medium' })
Vue.use(VueQuillEditor)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
